import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["fetch"] = "order/fetch";
    ActionTypes["fetchSuccess"] = "order/fetchSuccess";
    ActionTypes["fetchError"] = "order/fetchError";
    ActionTypes["reset"] = "order/reset";
    ActionTypes["setOrderCreated"] = "order/setOrderCreated";
    ActionTypes["setAddOnOrder"] = "order/setAddOnOrder";
    ActionTypes["updateInstalmentsPrice"] = "order/updateInstalmentsPrice";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    fetch: createAction(ActionTypes.fetch, () => {
        window.__GLOBAL_CONTEXT__.orderLoading = true;
        return {
            payload: {}
        };
    }),
    fetchSuccess: createAction(ActionTypes.fetchSuccess, (order) => {
        window.__GLOBAL_CONTEXT__.soylentEmail = order?.soylentEmail;
        window.__GLOBAL_CONTEXT__.orderLoading = false;
        return {
            payload: { order }
        };
    }),
    fetchError: createAction(ActionTypes.fetchError, (error) => {
        window.__GLOBAL_CONTEXT__.orderLoading = false;
        return {
            payload: { error }
        };
    }),
    setOrderCreated: createAction(ActionTypes.setOrderCreated, (payload) => ({
        payload
    })),
    setAddOnOrder: createAction(ActionTypes.setAddOnOrder, (addOnOrder) => ({
        payload: { addOnOrder }
    })),
    reset: createAction(ActionTypes.reset, () => ({
        payload: {}
    })),
    updateInstalmentsPrice: createAction(ActionTypes.updateInstalmentsPrice, (payload) => ({
        payload
    }))
};
